// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";

function MakeCellSelector(C) {
  var Cell_selector$MakeCellSelector = function (Props) {
    var cs = Props.cs;
    return React.createElement("div", {
                className: "selector"
              }, React.createElement("div", {
                    className: "selector-header"
                  }, C.name), React.createElement("div", {
                    className: "overflow-y " + C.name
                  }, React.createElement(React.Fragment, undefined, $$Array.of_list(List.map((function (c) {
                                  return Curry._1(C.render, c);
                                }), cs)))));
  };
  return {
          empty: /* [] */0,
          make: Cell_selector$MakeCellSelector
        };
}

export {
  MakeCellSelector ,
  
}
/* react Not a pure module */
